import { useState } from 'react'

// A render-phase state update, not the useRef+useEffect recipe: that one tracks the previous RENDER, so any
// unrelated re-render decays `previous` to the current value (reactjs/react.dev#2558, streamich/react-use#476).
export function usePreviousValue<T>(value: T, changeKey: string): { current: T; previous: T | null } {
  const [tracked, setTracked] = useState<{ key: string; current: T; previous: T | null }>(() => ({
    key: changeKey,
    current: value,
    previous: null,
  }))

  if (tracked.key !== changeKey) {
    setTracked({ key: changeKey, current: value, previous: tracked.current })
  }

  // `changeKey` must be a pure function of `value`: callers derive fresh objects, so an identity guard would never terminate.
  return tracked
}
